<ng-container [formGroup]="group()">

  <label [for]="id + '-tag'" i18n>Tag:</label>
  <div class="form-array">
    <input #tagInput
           [id]="id + '-tag'"
           type="text"
           inputmode="email"
           autocorrect="off"
           autocapitalize="none"
           formControlName="tag"
           (keydown)="$event.key === 'Enter' && validate(tagInput) || true"
           (blur)="blur(tagInput)">
    @if (showClear()) {
      <button type="button" (click)="clear.emit()" i18n-title title="New User" i18n>🆑️</button>
    }
  </div>

  <label [for]="id + '-name'" i18n>Name:</label>
  <input [id]="id + '-name'" type="text" formControlName="name">

  <label [for]="id + '-role'" i18n>Role:</label>
  <select [id]="id + '-role'" formControlName="role">
    <option value="ROLE_ADMIN" i18n>admin</option>
    <option value="ROLE_MOD" i18n>mod</option>
    <option value="ROLE_EDITOR" i18n>editor</option>
    <option value="ROLE_USER" i18n>user</option>
    <option value="ROLE_VIEWER" i18n>viewer</option>
    <option value="ROLE_ANONYMOUS" i18n>anon</option>
    <option value="ROLE_BANNED" i18n>banned</option>
  </select>

  <app-tags
            i18n-label label="Notifications:"
            fieldName="notifications"
            emoji="✉️"
            [group]="group()" />

  <app-tags
            i18n-label label="Read Access:"
            fieldName="readAccess"
            [group]="group()" />

  <app-tags
            i18n-label label="Write Access:"
            fieldName="writeAccess"
            [group]="group()" />

  <app-tags
            i18n-label label="Tag Read Access:"
            fieldName="tagReadAccess"
            [group]="group()" />

  <app-tags
            i18n-label label="Tag Write Access:"
            fieldName="tagWriteAccess"
            [group]="group()" />

  @if (showPubKey()) {
    <label [for]="id + '-pubKey'" i18n>SSH Public Key:</label>
    <div>
      <textarea [id]="id + '-pubKey'"
                formControlName="pubKey"></textarea>
    </div>
  }

  <label [for]="id + '-authorizedKeys'" i18n>Authorized Keys:</label>
  <div>
    <textarea [id]="id + '-authorizedKeys'"
              formControlName="authorizedKeys"></textarea>
  </div>

  @if (store.account.mod || external()) {
    <label [for]="id + '-external'" i18n>External Config:</label>
    @if (!editingExternal() && !external()) {
      <div>
        <button type="button" (click)="editingExternal.set(true)" i18n>+ Add Config</button>
      </div>
    } @else {
      <app-json (focusin)="editingExternal.set(true)" [id]="id + '-external'"
                fieldName="external"
                [style.pointer-events]="store.account.mod ? 'auto' : 'none'"
                [group]="group()" />
      @if (externalErrors().length) {
        <span><!-- Errors --></span>
        @for (e of externalErrors(); track e) {
          <div>
            <span class="error">{{ e }}</span>
          </div>
        }
      }
    }
  }

</ng-container>
